import GetStudentTypeMixin from '@/mixins/student-type';
import { VRuntimeShell } from '@grupoa/components';

export default {
  props      : ['content', 'title'],
  mixins     : [GetStudentTypeMixin],
  components : {
    VRuntimeShell
  },
  data() {
    return {
      applicationBaseUrl: process.env.APPLICATION_ROUTE_BASE
    };
  }
};
